// @flow-ignore
import * as ColorNames from '../common/colorNames';
import * as SplunkColors from './colorsText';

export const PRIMARY = SplunkColors.INTERACTIVE_PRIMARYACTION;
export const SECONDARY = ColorNames.THUNDER;
export const TERTIARY = Object.assign({}, SplunkColors.NEUTRALS_WHITE, {
  buttonText: SplunkColors.INTERACTIVE_PRIMARYACTION.hex
}); // Tertiary is always white button blue background
export const BRAND_PRIMARY = ColorNames.MARINER;
export const BRAND_SECONDARY = ColorNames.ATOMIC_TANGERINE;
export const SUCCESS = SplunkColors.ACCENTS_POSITIVE;
export const INFO = SplunkColors.STATUS_INFO;
export const WARNING = SplunkColors.ACCENTS_WARNING;
export const DANGER = SplunkColors.ACCENTS_NEGATIVE;
export const LIGHT = ColorNames.ATHENS_GRAY;
export const DARK = ColorNames.FJORD;
export const CONTRAST = ColorNames.FJORD;
export const BLACK = ColorNames.BLACK;
export const WHITE = ColorNames.WHITE;
export const TEXT = SplunkColors.CONTENT_DEFAULT;
export const TEXT_ACTIVE = SplunkColors.CONTENT_ACTIVE;
export const TEXT_INVERSE = SplunkColors.CONTENT_INVERTED;
export const LINK_TEXT = ColorNames.MARINER;
export const SURFACE = SplunkColors.BACKGROUND_PAGE;
export const DARK_SURFACE_LIGHTER = SplunkColors.BACKGROUND_SECTION;
export const SURFACE_INVERSE = SplunkColors.GREY;
export const SURFACE_LIGHTER = SplunkColors.BACKGROUND_SECTION;
export const SURFACE_LIGHTEST = SplunkColors.BACKGROUND_SECTION;
export const INPUT_DISABLED = SplunkColors.INTERACTIVE_DISABLEDBACKGROUND;
export const BOX_SHADOW = SplunkColors.GREY;

// export const BORDER = SplunkColors.INTERACTIVE_DEFAULTBORDER;
export const BORDER = SplunkColors.NEUTRALS_GREY400;

export const LIGHT_GRAY_SURFACE = SplunkColors.NEUTRALS_GREY100;

/* -------------- Component Specific Styles -------------- */

// Search / Reports / Entities Page
export const SEARCH_RESULTS = {
  TITLE: SplunkColors.STATUS_INFO.hex,
};

export const SEARCH_BAR = ColorNames.THUNDER;
export const SEARCH_BAR_INPUT = ColorNames.THUNDER;
export const SEARCH_FILTER_BAR = SplunkColors.BACKGROUND_SECTION;
export const SEARCH_FILTER_BAR_BUTTON = ColorNames.THUNDER;

// Side Nav Remains Black in Default
export const SIDE_NAV_BAR = ColorNames.THUNDER;
export const SIDE_NAV_BAR_HOVER = ColorNames.TUNDORA;

// Main Nav Bar
export const SIDE_NAV_DROPRIGHT_MENU_ITEM = {
  BACKGROUND: SURFACE.hex,
  BACKGROUND_HOVER: BLACK.X500,
  TEXT: TEXT.hex,
  TEXT_HOVER: TEXT.hex,
  SHADOW: BLACK.X200,
  BORDER_RIGHT: TEXT.hex
};

export const SETTINGS_PAGE_NAVLINK = SIDE_NAV_DROPRIGHT_MENU_ITEM;



// WEBPACK FOOTER //
// ./web_modules/trustar-2.0/themes/splunk-dark/themeColors.js